import terminologyStore from "../store/terminologyStore";

export default {
  lookup: id => {
    return terminologyStore && terminologyStore.state && terminologyStore.state.terminologies
      ? terminologyStore.state.terminologies[id]
      : "";
  },
};
